// INSTANCES
import { ApiAxiosInstance } from '../instances/apiAxiosInstance';

// TYPES
import type { KycCompliance } from '@/types/KycCompliance';

export const authClient = {
  /**
   * @deprecated Usar authService.getKycStatus() de @/shared/common/services/auth.service
   */
  async getKycStatus() {
    try {
      const response = await ApiAxiosInstance.get<KycCompliance>(
        'company/b2b/kyc/status'
      );
      const data = JSON.stringify(response.data);

      localStorage.setItem('g-kyc-status', data);

      return response;
    } catch (err) {
      return Promise.reject(err);
    }
  },

  /**
   * @deprecated Usar authenticationService.getAvailableOnboardingCountries() de @/modules/authentication/services/authentication.service
   */
  getAvailableOnboardingCountries() {
    return ApiAxiosInstance.get('company/ext/onboarding/sing-up/countries');
  },
};
